// Icona prenotazioni: busta piena (envelope solid)
export default function BookingTableIcon(props) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			width="1em"
			height="1em"
			fill="currentColor"
			aria-hidden="true"
			{...props}
		>
			<path d="M3.75 4.5h16.5A1.75 1.75 0 0 1 22 6.25v11.5A1.75 1.75 0 0 1 20.25 19.5H3.75A1.75 1.75 0 0 1 2 17.75V6.25A1.75 1.75 0 0 1 3.75 4.5Z" />
			<path
				d="M4 6.5 12 12l8-5.5"
				fill="none"
				stroke="#fff"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
